import { FUNCTION } from '../constants';

export const queryFunctionLoad = () => {
    return {
        type: FUNCTION.FUNCTION_QUERY_LOAD
    }
}

export const queryFunction = (formData) => {
    return {
        type: FUNCTION.FUNCTION_QUERY,
        formData: formData
    }
}

export const queryFunctionSuccess = (token, result) => {
	sessionStorage.setItem('token', token);

    return {
        type: FUNCTION.FUNCTION_QUERY_SUCCESS,
        result: result
    }
}